import { api } from '@api'
import { ApiParams, Carrier } from '@types'

interface GetCarriersResponse {
  carriers: { carriers: Carrier[] }
}

interface FilteredCarriersResponse {
  carriers: Carrier[]
  total: number
}

interface GetFilteredCarriersResponse {
  carriers: FilteredCarriersResponse
}

export interface Form {
  carrierId: number
  category?: number
  enabledForAlgorithm?: boolean
}

const getCarriers = async () => {
  const response = await api.get<GetCarriersResponse>('/carriers')

  return response.data.carriers.carriers
}

const getCarriersWithFilters = async ({ filters }: ApiParams) => {
  const response = await api.get<GetFilteredCarriersResponse>('/carriers', {
    params: {
      ...filters,
    },
  })

  return response.data.carriers
}

const changeOptions = async (payload: Form) => {
  const { carrierId, ...restOfValues } = payload
  const response = await api.put<GetCarriersResponse>(`/carriers/${carrierId}`, {
    carrier: restOfValues,
  })

  return response.data
}

export const CarriersApi = { getCarriers, getCarriersWithFilters, changeOptions }
